import React from 'react';
import {Switch, Redirect} from 'react-router-dom';
import Object from './components/Mandatory_Network_Inspection_Waiver';
import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

export default ({match}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Object />
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
